import * as yup from "yup";

const currentYear = new Date().getFullYear();

export const UpdateFacultyFormValidation = yup
  .object()
  .shape({
    description: yup.string().required("Descrição é obrigatória"),
    abbreviation: yup.string().nullable().optional(),
    address: yup.string(),
    province: yup.string().required(),
    district: yup.string().nullable().optional(),
    id: yup.string().optional(),
    idProvince: yup.string().optional(),
    idUniversity: yup.string().optional(),
    nuit: yup
      .string()
      .matches(
        /^[1-9]\d{8}$/,
        "NUIT deve conter exatamente 9 dígitos numéricos")
      .nullable().optional(),

    code: yup.string().nullable().nullable().optional(),
    dirigentFullname: yup.string().nullable().optional(),
    responsableFullname: yup.string().nullable().optional(),
    yearCreated: yup
      .number()
      .typeError("Ano de criação deve ser numérico")
      .integer("Ano inválido")
      .min(1900, "Ano deve ser maior ou igual a 1900")
      .max(currentYear, `Ano não pode ser maior que ${currentYear}`)
      .nullable().optional(),

    dateCreated: yup.string().typeError("Data de criação inválida").nullable().optional(),

    // type: yup.string().oneOf(["public", "private"], "Tipo inválido"),

    status: yup.boolean().required("Status é obrigatório"),

    website: yup.string().url("URL do website inválida").nullable().optional(),

    email: yup.string().email("Email da instituição inválido").nullable().optional(),

    dirigentEmail: yup.string().email("Email do dirigente inválido").nullable().optional(),

    dirigentPhoneNumber: yup
      .string()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, "Número de telemóvel inválido")
      .nullable().optional(),

    responsableEmail: yup
      .string()
      .email("Email do responsável inválido")
      .nullable().optional(),

    responsablePhoneNumber: yup
      .string()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, "Número de telemóvel inválido")
      .nullable().optional(),
  })
  .test(
    "year-date-match",
    "Ano de criação deve corresponder ao ano da data de criação",
    function (values) {
      const { yearCreated, dateCreated } = values as any;

      if (!yearCreated || !dateCreated) return true;

      const dateYear = new Date(dateCreated).getFullYear();
      return dateYear === yearCreated;
    }
  );
